export const PAYMENT_LOAD_ATTEMPT = "PAYMENT_LOAD_ATTEMPT";
export const PAYMENT_LOAD_SUCCESS = "PAYMENT_LOAD_SUCCESS";
export const PAYMENT_LOAD_FAILED = "PAYMENT_LOAD_FAILED";
///////////////////////////
export const PAYMENT_SAVE_ATTEMPT = "PAYMENT_SAVE_ATTEMPT";
export const PAYMENT_SAVE_SUCCESS = "PAYMENT_SAVE_SUCCESS";
export const PAYMENT_SAVE_FAILED = "PAYMENT_SAVE_FAILED";
